import React from 'react';
import {Form, Input, Row, Col, message, Table, Radio, Button, Tooltip} from 'antd';
import axios from 'axios';
import './App.css';
import './markdown.css';
import Card from "antd/lib/card";
import copy from "copy-to-clipboard";
import Read from "./Read";

const {Search} = Input;

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formLayout: 'horizontal',
            addressValue: 0,
            typeValue: 0,
            resultSet: [],
            visible: false,
            style: {
                display: "none"
            },
            column: [
                {
                    title: '原地址',
                    key: 'originUrl',
                    checked: 'true',
                    render: (record) => {
                        return (
                            <Tooltip placement="topLeft" title={record.originUrl}>
                                <div>{record.originUrl}</div>
                            </Tooltip>
                        );
                    }
                },
                {
                    title: '缩短的地址',
                    key: 'shortenPath',
                    checked: 'true',
                    render: (record) => {
                        return (
                            <Tooltip placement="topLeft" title={record.shortenPath}>
                                <div>{record.shortenPath}</div>
                            </Tooltip>
                        );
                    }
                },
                {
                    title: '缩短的地址模板',
                    key: 'shortenUrl',
                    checked: 'true',
                    render: (record) => {
                        return (
                            <Tooltip placement="topLeft" title={record.shortenUrl}>
                                <div>{record.shortenUrl}</div>
                            </Tooltip>
                        );
                    }
                },
                {
                    render: (record) => {
                        return (
                            <Button type={"primary"} onClick={this.copyText.bind(this, record)}>一键复制</Button>
                        );
                    },
                },
            ],
        };
    }

    handleClick = value => {
        const url = value.trim();
        if (url === "" || url === null) {
            message.error("请输入网址");
            return;
        }
        const params = {
            url: url,
            type: this.state.addressValue,
            templateType: this.state.typeValue
        }
        axios.post("/api/shorten", params).then(res => {
            if (res.data.code === '200') {
                const result = res.data;
                const resultSet = [];
                resultSet.push(result.data);
                this.setState({
                    resultSet,
                    style: {
                        display: "block"
                    }
                });
                message.success(res.data.message || "生成成功");
            }
        }).catch(() => {
            message.error("短链接生成失败");
        });
    }
    handleShortLinkChange = e => {
        this.setState({
            addressValue: e.target.value,
        });
    };
    handleDynamicAddressChange = e => {
        this.setState({
            typeValue: e.target.value,
        });
    };
    handleColor = () => {
        const className = "table-bg";
        return className;
    }
    copyText = record => {
        copy(record.shortenPath);
        message.success("复制成功")
    }

    render() {
        const {formLayout} = this.state;
        return (
            <div className="App">
                <h1 className="h1">欧飞短链接生成平台</h1>
                <Form layout={formLayout}>
                    <Row gutter={24}>
                        <Col span={5}/>
                        <Col span={14}>
                            <Search
                                placeholder="请输入网址"
                                enterButton="一键缩短"
                                size="large"
                                onSearch={this.handleClick.bind(this)}
                            />
                        </Col>
                    </Row>
                </Form>
                <Row gutter={24} className="row">
                    <Col span={6}/>
                    <Col span={6}>
                        <Radio.Group onChange={this.handleShortLinkChange.bind(this)} value={this.state.addressValue}>
                            <span>短链接类型:</span><br/><br/>
                            <Radio value={0}><span>静态短链接</span></Radio>
                            <Radio value={1}><span>动态短链接</span></Radio>
                        </Radio.Group>
                    </Col>
                    <Col span={6}>
                        <Radio.Group onChange={this.handleDynamicAddressChange.bind(this)} value={this.state.typeValue}>
                            <span>动态地址形式:</span><br/><br/>
                            <Radio value={0}><span>路径变量形式</span></Radio>
                            <Radio value={1}><span>查询参数形式</span></Radio>
                        </Radio.Group>
                    </Col>
                </Row>
                <Row gutter={24} className="row">
                    <Col span={5}/>
                    <Col span={14}>
                        <Card className="card" span={14}>
                            <Table
                                columns={this.state.column}
                                pagination={false}
                                dataSource={this.state.resultSet}
                                rowClassName={this.handleColor.bind(this)}
                                style={this.state.style}
                            />
                        </Card>
                    </Col>
                </Row>
                <Row gutter={24} className="row">
                    <Col span={5}/>
                    <Col span={14}>
                        <Card className="card" span={14}>
                            <Read/>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default App;
